module.exports = __webpack_public_path__ + "img/czyszczenie-klimatyzacji.2592a483.jpg";